<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="add-to-order-back-button"
        text=""
      ></ion-back-button>
    </ion-buttons>
    <ion-label data-cy="add-to-order-text">
      {{ 'i18n.orderPage.addToOrderModal.addToExistingOrder' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-content-modal-mobile">
  <div class="start-label-container">
    <span class="start-order-label" data-cy="start-order-label">
      {{ 'i18n.orderPage.addToOrderModal.selectExistingOrder' | translate }}
    </span>

    <ion-radio-group>
      <ng-container
        *ngFor="let rowItem of vm; trackBy: trackItem; let i = index"
      >
        <app-add-to-order-products
          (selectionEmitter)="onOrderSelected(rowItem)"
          [vm]="vm[i]"
          [index]="i"
        ></app-add-to-order-products>
      </ng-container>
    </ion-radio-group>
  </div>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        class="usf-outline-green-mobile-modal-button"
        data-cy="add-to-order-cancel-button"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        [ngClass]="
          !!selectedOrderDetails
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-disabled-mobile-modal-button'
        "
        data-cy="add-to-order-next-button"
        [disabled]="!selectedOrderDetails"
        (click)="onSubmit()"
      >
        {{ 'i18n.orderPage.addToOrderModal.addProduct' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
